import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

const API_URL = process.env.REACT_APP_API_URL || 'https://apiprov.conduto.com.ec';

const DatosProveedorModal = ({ show, handleClose, formulario }) => {
  const [activeSection, setActiveSection] = useState('info-basica');
  const [accionistas, setAccionistas] = useState([]);
  const [loadingAccionistas, setLoadingAccionistas] = useState(false);
  const [accionistasTotal, setAccionistasTotal] = useState(0);
  const [referencias, setReferencias] = useState([]);
  const [loadingReferencias, setLoadingReferencias] = useState(false);
  const [politicas, setPoliticas] = useState([]);
  const [loadingPoliticas, setLoadingPoliticas] = useState(false);

  const proveedor = formulario?.proveedor_datos || {};
  const isJuridica = formulario?.usuario?.tipo_persona === 'juridica';

  useEffect(() => {
    if (formulario?.id_formulario && show) {
      cargarAccionistas();
      cargarReferencias();
      cargarPoliticas();
    }
  }, [formulario?.id_formulario, show]);

  const cargarAccionistas = async () => {
    if (!formulario?.id_formulario) return;

    setLoadingAccionistas(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_URL}/api/providers/accionistas/${formulario.id_formulario}`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'include'
      });

      if (res.ok) {
        const data = await res.json();
        const accionistasArray = Array.isArray(data) ? data : data.accionistas || [];
        setAccionistas(accionistasArray);

        const total = accionistasArray.reduce((s, a) => s + a.porcentaje, 0);
        setAccionistasTotal(total);
      }
    } catch (error) {
      console.error("Error cargando accionistas:", error);
    } finally {
      setLoadingAccionistas(false);
    }
  };

  const cargarReferencias = async () => {
    if (!formulario?.id_formulario) return;

    setLoadingReferencias(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_URL}/api/providers/referencias/${formulario.id_formulario}`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'include'
      });

      if (res.ok) {
        const data = await res.json();
        const referenciasArray = Array.isArray(data) ? data : data.referencias || [];
        setReferencias(referenciasArray);
      }
    } catch (error) {
      console.error("Error cargando referencias:", error);
    } finally {
      setLoadingReferencias(false);
    }
  };

  const cargarPoliticas = async () => {
    if (!formulario?.id_formulario) return;

    setLoadingPoliticas(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_URL}/api/documentos/politicas-aceptadas/${formulario.id_formulario}`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: 'include'
      });

      if (res.ok) {
        const data = await res.json();
        console.log("Políticas aceptadas:", data);
        setPoliticas(data);
      }
    } catch (error) {
      console.error("Error cargando políticas:", error);
    } finally {
      setLoadingPoliticas(false);
    }
  };

  const formatBoolean = (value) => {
    if (value === true) return 'SI';
    if (value === false) return 'NO';
    return 'N/A';
  };

  const formatValue = (value) => {
    return value || 'N/A';
  };

  const formatRegimenRimpe = (regimen) => {
    if (!regimen) return 'N/A';
    const map = {
      'NEGOCIO POPULAR': 'NEGOCIO POPULAR',
      'EMPRENDEDOR': 'EMPRENDEDOR',
      'GENERAL': 'GENERAL'
    };
    return map[regimen] || regimen;
  };

  const getFileUrl = (rutaArchivo) => {
    if (!rutaArchivo) return "#";
    const rutaCodificada = encodeURIComponent(rutaArchivo);
    return `${API_URL}/api/documentos/visualizar/${rutaCodificada}`;
  };

  const getFileName = (rutaArchivo) => {
    if (!rutaArchivo) return "Sin archivo";
    const partes = rutaArchivo.split('/');
    return partes[partes.length - 1];
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered scrollable>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title style={{ color: '#00022577' }}>
          <i className="bi bi-building me-2"></i>
          Datos del Proveedor - {formulario?.titulo || 'Formulario'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <div className="mb-4">
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className={`nav-link ${activeSection === 'info-basica' ? 'active' : ''}`}
                onClick={() => setActiveSection('info-basica')}
                type="button"
              >
                Información Básica
              </button>
              {isJuridica && (
                <>
                  <button
                    className={`nav-link ${activeSection === 'accionistas' ? 'active' : ''}`}
                    onClick={() => setActiveSection('accionistas')}
                    type="button"
                  >
                    Accionistas
                  </button>
                  <button
                    className={`nav-link ${activeSection === 'referencias' ? 'active' : ''}`}
                    onClick={() => setActiveSection('referencias')}
                    type="button"
                  >
                    Referencias Comerciales
                  </button>
                </>
              )}
              <button
                className={`nav-link ${activeSection === 'transferencias' ? 'active' : ''}`}
                onClick={() => setActiveSection('transferencias')}
                type="button"
              >
                Transferencias
              </button>
              <button
                className={`nav-link ${activeSection === 'retenciones' ? 'active' : ''}`}
                onClick={() => setActiveSection('retenciones')}
                type="button"
              >
                Retenciones
              </button>
              <button
                className={`nav-link ${activeSection === 'politicas' ? 'active' : ''}`}
                onClick={() => setActiveSection('politicas')}
                type="button"
              >
                Políticas Aceptadas
              </button>
            </div>
          </nav>
        </div>

        {activeSection === 'info-basica' && (
          <div className="form-section">
            <h5 className="form-title bg-light p-2 mb-3 border-bottom">
              INFORMACIÓN DEL PROVEEDOR
            </h5>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">NÚMERO DE RUC:</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.ruc)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">
                  {isJuridica ? 'RAZÓN SOCIAL:' : 'NOMBRES COMPLETOS:'}
                </label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.razon_social)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">
                  {isJuridica ? 'RAZÓN COMERCIAL:' : 'APELLIDOS COMPLETOS:'}
                </label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.razon_comercial)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">CARGO:</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.cargo)}
                </div>
              </div>

              <div className="col-12 mb-3">
                <label className="form-label fw-bold">Servicios / Suministros que presta:</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.servicios_prestados)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">Provincia:</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.provincia)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">Cantón:</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.canton)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">CONTRIBUYENTE ESPECIAL:</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatBoolean(proveedor.contribuyente_especial)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">RÉGIMEN RIMPE:</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatRegimenRimpe(proveedor.regimen_rimpe)}
                </div>
              </div>

              <div className="col-12 mb-3">
                <label className="form-label fw-bold">DIRECCIÓN DE ESTABLECIMIENTO</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.direccion_establecimiento)}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">TELÉFONO 1</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.telefono1)}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">TELÉFONO 2</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.telefono2)}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">TELÉFONO 3</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.telefono3)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">PERSONA DE CONTACTO</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.persona_contacto)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">EMAIL DE CONTACTO</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.email_contacto)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">FORMA DE PAGO</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.forma_pago)}
                </div>
              </div>

              {proveedor.forma_pago === 'Otro' && proveedor.forma_pago_otro && (
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">FORMA DE PAGO ESPECIFICADA</label>
                  <div className="form-control-plaintext border rounded p-2 bg-light">
                    {formatValue(proveedor.forma_pago_otro)}
                  </div>
                </div>
              )}

              {isJuridica && (
                <>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Representante Legal</label>
                    <div className="form-control-plaintext border rounded p-2 bg-light">
                      {formatValue(proveedor.representante_legal)}
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Cédula Representante</label>
                    <div className="form-control-plaintext border rounded p-2 bg-light">
                      {formatValue(proveedor.cedula_representante)}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {activeSection === 'accionistas' && isJuridica && (
          <div className="form-section">
            <h5 className="form-title bg-light p-2 mb-3 border-bottom">
              INFORMACIÓN DE ACCIONISTAS
            </h5>

            {loadingAccionistas ? (
              <div className="text-center py-4">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando accionistas...</span>
                </Spinner>
                <p className="mt-2">Cargando información de accionistas...</p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-hover table-sm">
                    <thead className="table-light">
                      <tr>
                        <th scope="col" className="w-50">Nombre del Accionista</th>
                        <th scope="col" className="w-25">Cédula/RUC</th>
                        <th scope="col" className="w-25 text-center">Participación %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accionistas.length === 0 ? (
                        <tr>
                          <td colSpan="3" className="text-center text-muted py-3">
                            No se han registrado accionistas
                          </td>
                        </tr>
                      ) : (
                        accionistas.map((accionista, index) => (
                          <tr key={accionista.id} className={index % 2 === 0 ? '' : 'table-active'}>
                            <td className="fw-medium">{accionista.nombre}</td>
                            <td className="text-muted">{accionista.cedula}</td>
                            <td className="text-center fw-bold">{accionista.porcentaje}%</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="mt-4 p-3 rounded" style={{
                  backgroundColor: accionistasTotal >= 20 ? '#d1edff' : '#fff3cd',
                  border: `1px solid ${accionistasTotal >= 20 ? '#b6d7fe' : '#ffeaa7'}`
                }}>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="d-flex align-items-center">
                        <div className={`me-3 ${accionistasTotal >= 20 ? 'text-success' : 'text-warning'}`}>
                          <i className={`bi ${accionistasTotal >= 20 ? 'bi-check-circle-fill' : 'bi-info-circle-fill'} fs-5`}></i>
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">Resumen de Participación</h6>
                          <div className="small">
                            Total acumulado: <span className="fw-bold">{accionistasTotal.toFixed(2)}%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="progress mb-2" style={{ height: '8px' }}>
                        <div
                          className={`progress-bar ${accionistasTotal >= 20 ? 'bg-success' : 'bg-warning'}`}
                          style={{ width: `${Math.min(accionistasTotal, 100)}%` }}
                          role="progressbar"
                          aria-valuenow={accionistasTotal}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <div className="small text-muted">
                        {accionistasTotal >= 20 ? (
                          <span className="text-success">
                            <i className="bi bi-check-circle me-1"></i>
                            Cumple con el mínimo requerido (20%)
                          </span>
                        ) : (
                          <span className="text-warning">
                            <i className="bi bi-info-circle me-1"></i>
                            Requiere al menos 20% de participación total
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {activeSection === 'referencias' && isJuridica && (
          <div className="form-section">
            <h5 className="form-title bg-light p-2 mb-3 border-bottom">
              REFERENCIAS COMERCIALES
            </h5>

            {loadingReferencias ? (
              <div className="text-center py-4">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando referencias...</span>
                </Spinner>
                <p className="mt-2">Cargando referencias comerciales...</p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-hover table-sm">
                    <thead className="table-light">
                      <tr>
                        <th scope="col" className="w-40">Nombre de la Empresa</th>
                        <th scope="col" className="w-30">Teléfono</th>
                        <th scope="col" className="w-30">Persona de Contacto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {referencias.length === 0 ? (
                        <tr>
                          <td colSpan="3" className="text-center text-muted py-3">
                            No se han registrado referencias comerciales
                          </td>
                        </tr>
                      ) : (
                        referencias.map((referencia, index) => (
                          <tr key={referencia.id} className={index % 2 === 0 ? '' : 'table-active'}>
                            <td className="fw-medium">{referencia.nombre}</td>
                            <td>{referencia.telefono}</td>
                            <td>{referencia.contacto}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        )}

        {activeSection === 'transferencias' && (
          <div className="form-section">
            <h5 className="form-title bg-light p-2 mb-3 border-bottom">
              INFORMACIÓN PARA TRANSFERENCIAS BANCARIAS
            </h5>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">EMAIL PARA TRANSFERENCIAS</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.email_transferencia)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">TIPO DE CUENTA</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.tipo_cuenta)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">NÚMERO DE CUENTA</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.numero_cuenta)}
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">NOMBRE DEL BANCO</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.nombre_banco)}
                </div>
              </div>
            </div>
          </div>
        )}

        {activeSection === 'retenciones' && (
          <div className="form-section">
            <h5 className="form-title bg-light p-2 mb-3 border-bottom">
              INFORMACIÓN PARA ENVÍO DE RETENCIÓN ELECTRÓNICA
            </h5>

            <div className="row">
              <div className="col-12 mb-3">
                <label className="form-label fw-bold">EMAIL PARA RETENCIONES</label>
                <div className="form-control-plaintext border rounded p-2 bg-light">
                  {formatValue(proveedor.email_retencion)}
                </div>
              </div>
            </div>
          </div>
        )}


        {activeSection === 'politicas' && (
          <div className="form-section">
            <h5 className="form-title bg-light p-2 mb-3 border-bottom">
              POLÍTICAS ACEPTADAS POR EL PROVEEDOR
            </h5>

            {loadingPoliticas ? (
              <div className="text-center py-4">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando políticas...</span>
                </Spinner>
                <p className="mt-2">Cargando políticas aceptadas...</p>
              </div>
            ) : (
              <>
                {politicas.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    <i className="bi bi-file-earmark-text fs-1 d-block mb-2"></i>
                    <p>No hay políticas aceptadas por el proveedor</p>
                  </div>
                ) : (
                  <div className="row">
                    {politicas.map((politica, index) => (
                      <div key={politica.id_pregunta} className="col-12 mb-3">
                        <div className="card border-success h-100">
                          <div className="card-header bg-success bg-opacity-10 d-flex justify-content-between align-items-center">
                            <h6 className="mb-0 fw-bold text-success">
                              <i className="bi bi-check-circle-fill me-2 text-success"></i>
                              {politica.titulo}
                            </h6>
                            <span className="badge bg-success">Aceptada</span>
                          </div>
                          <div className="card-body">
                            {politica.descripcion && (
                              <p className="card-text text-muted small mb-2">
                                {politica.descripcion}
                              </p>
                            )}
                            {politica.ruta_archivo ? (
                              <div className="mt-2">
                                <a
                                  href={getFileUrl(politica.ruta_archivo)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-outline-primary btn-sm"
                                >
                                  <i className="bi bi-file-earmark-pdf me-1"></i>
                                  Ver documento adjunto: {getFileName(politica.ruta_archivo)}
                                </a>
                              </div>
                            ) : (
                              <div className="mt-2 text-muted small">
                                <i className="bi bi-info-circle me-1"></i>
                                Esta política no requiere documento adjunto
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100 d-flex justify-content-between align-items-center">
          <small className="text-muted">
            Formulario ID: {formulario?.id_formulario || 'N/A'} |
            Tipo: {isJuridica ? 'Jurídica' : 'Natural'} |
            Políticas aceptadas: {politicas.length}
          </small>
          <Button variant="secondary" onClick={handleClose}>
            <i className="bi bi-x-circle me-1"></i>
            Cerrar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DatosProveedorModal;